import { Toast } from "vant";

export const mixins = {
  data() {
    return {
      urlList: [
        // 91 Porn
        {
          url: "https://d2yfph5h6p3thl.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-91porn.png"),
          name: "91porn",
          time: 0,
        },
        // 欲漫涩
        {
          url: "https://d14x1n9hwm0jex.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-ysm.png"),
          name: "ysm",
          time: 0,
        },
        //麻豆传媒  
        // {
        //   url: "https://d3fl8m2zzcf4sv.cloudfront.net?dc=lqz01",
        //   icon: require("./../assets/png/app-mdcm.png"),
        //   name: "mdcm",
        //   time: 0,
        // },
        // 海角
        {
          url: "https://d2chkh29au2ik7.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-hjsq.png"),
          name: "hjsq",
          time: 0,
        },
        // oio禁漫
        {
          url: "https://d20jtpyq1zxrl9.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-oio.png"),
          name: "oio",
          time: 0,
        },
        // 稚青社
        {
          url: "https://d206e5xt9o2gjs.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-yqs.png"),
          name: "yqs",
          time: 0,
        },
        // 快手
        {
          url: "https://d2bt7qhl7htdhn.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-ks.png"),
          name: "ks",
          time: 0,
        },
        // 好色
        {
          url: "https://d8h4a0sjrkkb.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-haose.png"),
          name: "haose",
          time: 0,
        },
        // 暗网XV
        {
          url: "https://d1x8pq0exjg39r.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-xvan.png"),
          name: "xvan",
          time: 0,
        },

        // 哔哩哔哩
        {
          url: "https://d2dp1xebtz7qs5.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-bilibili.png"),
          name: "bilibili",
          time: 0,
        },
        // 稚青社
        {
          url: "https://d206e5xt9o2gjs.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-yqs1.png"),
          name: "yqs1",
          time: 0,
        },
        // P站精品版
        {
          url: "https://d1bccerqyxckfu.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-pzjp.png"),
          name: "pzjp",
          time: 0,
        },
        // 萝莉岛2
        {
          url: "https://d2tjxohdijxsuv.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-lld.png"),
          name: "lld",
          time: 0,
        },
        // 91暗网
        {
          url: "https://d1p5ephwvpcy64.cloudfront.net?dc=lqz01",
          icon: require("./../assets/png/app-91aw.png"),
          name: "91aw",
          time: 0,
        },
        // P站中文版
        {
          url: "https://d1rlofcsnbeh1t.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-pzzh.png"),
          name: "pzzh",
          time: 0,
        },
        // 妻友2
        {
          url: "https://d316xp3l06pokx.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-qy2.png"),
          name: "qy2",
          time: 0,
        },
        // 波多漫画
        {
          url: "https://d7zo6o6taat2d.cloudfront.net/?dc=lqz01",
          icon: require("./../assets/png/app-bdmh.png"),
          name: "bdmh",
          time: 0,
        },
      ], // 域名数组
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    jumpUrl(url) {
      window.open(url);
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        }
      );
    },
  },
};
